export default "__VITE_ASSET___GWWWHze__"